<template>
    <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3" id="content_screen">
    <div :class="'p-3 flex content-main gap-5'">
      <div class="custom-full">
        <div class="bg-[#2B2C32] rounded-lg px-[32px] max-w-full py-[16px] mb-[50px]">
          <iframe class="mb-3" :src="businessIframe" width="100%" height="900px"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent} from "vue"
import { mapGetters} from "vuex";
import Env from '@/env';

export default defineComponent({
  name: "ReportDashboard",

  computed: {
    /**
     * business and location iframes
     */
     businessIframe() {
        let businessID:any = this.vg_activeBusiness.id;
        let url:any = Env.dashboardUrl
        return url.replace(/__BUSINESSID__/g, businessID)
     },
    ...mapGetters({
      vg_activeBusiness: 'auth/activeBusiness',
    }),
  },
});

</script>